@if(showInscription) {
  <div class="container-fluid h-100">
    <router-outlet></router-outlet>
  </div>
}
@else {
  <app-waiting-screen></app-waiting-screen>
}
